import React from 'react';

import { Box, Button, Icon, Popover, SpaceBetween } from '@amzn/awsui-components-react-v3';

import { useGetUserInformation, logger } from 'appSelectorContext';
import { uniqueId } from 'lodash';

interface DeleteContainerProps {
  onDelete: () => void;
  onCancel?: () => void;
  disabled?: boolean;
}

export const DeleteContainer = ({ onDelete, onCancel, disabled = false }: DeleteContainerProps) => {
  const [key, setKey] = React.useState(uniqueId());
  const { user } = useGetUserInformation();

  const cancelPopover = () => setKey(uniqueId());

  const onHandleDelete = () => {
    logger.info(
      `delete container : ${JSON.stringify({
        withUser: user,
      })} `,
    );
    onDelete();
    cancelPopover();
  };

  if (disabled) {
    return (
      <Box margin={{ top: 'xl' }}>
        <Button variant="link" disabled>
          <Icon name="remove" />
          Delete container
        </Button>
      </Box>
    );
  }

  return (
    <Box margin={{ top: 'xl' }}>
      <Popover
        key={key}
        dismissButton={true}
        position="top"
        size="large"
        triggerType="custom"
        header="Confirm Delete"
        content={
          <Box>
            <p>All the parts scanned inside this container will be removed</p>
            <div className="confirm-actions">
              <SpaceBetween direction="horizontal" size="xs">
                <Button variant="link" onClick={cancelPopover}>
                  Cancel
                </Button>
                <Button variant="link" onClick={onHandleDelete}>
                  <SpaceBetween direction="horizontal" size="xs">
                    <Icon name="remove" variant="error" />
                    <Box variant="span" color="text-status-error">
                      Delete
                    </Box>
                  </SpaceBetween>
                </Button>
              </SpaceBetween>
            </div>
          </Box>
        }
      >
        <Button variant="link">
          <Icon name="remove" variant="error" />
          <Box variant="span" color="text-status-error">
            Delete container
          </Box>
        </Button>
      </Popover>
    </Box>
  );
};
